import { useMutation } from '@tanstack/react-query'
import { axiosInstance } from '@/lib/axios'
import type { CheckoutRequest } from '../types'

export function useMutationCreateCheckout(companyId: string) {
  return useMutation({
    mutationFn: async (body: CheckoutRequest): Promise<{ url: string; sessionId: string }> => {
      const { data } = await axiosInstance.post(
        `/config-api/${companyId}/subscription/checkout`,
        body,
      )
      return data
    },
  })
}
